import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations';
var i18n = createInstance({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    },
    resources: translations
});
i18n.use(initReactI18next).init();
export var t = i18n.t;
export default i18n;
//# sourceMappingURL=i18n.js.map